import React from 'react'
import {
    LineChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Line,
    ResponsiveContainer
  } from "recharts";
  // import {
  //   LineChart,
  //   CartesianGrid,
  //   XAxis,
  //   YAxis,
  //   Tooltip,
  //   Legend,
  //   Line,
  //   ComposedChart,
  //   Area,
  //   Bar,
  //   ResponsiveContainer
  // } from "recharts";
  const data = [
    {
      name: "Y-2014",
      ProductB: 4000,
      ProductA: 2400,
      amt: 2400
    },
    {
      name: "Y-2015",
      ProductB: 3000,
      ProductA: 1398,
      amt: 2210
    },
    {
      name: "Y-2016",
      ProductB: 2000,
      ProductA: 9800,
      amt: 2290
    },
    {
      name: "Y-2017",
      ProductB: 2780,
      ProductA: 3908,
      amt: 2000
    },
    {
      name: "Y-2018",
      ProductB: 1890,
      ProductA: 4800,
      amt: 2181
    },
    {
      name: "Y-2019",
      ProductB: 2390,
      ProductA: 3800,
      amt: 2500
    },
    {
      name: "Y-2020",
      ProductB: 3490,
      ProductA: 4300,
      amt: 2100
    }
  ];

export default function RenderLineChart(){
    return (
        <ResponsiveContainer>
        <LineChart
        // width={730}
        // height={250}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="ProductA" stroke="#8884d8" />
        <Line type="monotone" dataKey="ProductB" stroke="#82ca9d" />
      </LineChart>
      </ResponsiveContainer>
    )
}
  
